import { useState, useEffect } from 'react';
import {
  getFGInspectionLogs
} from '../states/PicklistAction'
import { OrderInspectionLog, ProductionOrder } from '../components/types';
import { Department, MachineCategory, OrderType } from '../models';
import { FGInspectionTypes } from '../constants/EnumType';
import { convertJson } from '../utilities/Validate';

interface UseFGInspectionLogParams {
  productionOrder: ProductionOrder,
  workCenterId: string,
  department: Department,
  isRefresh?: boolean,
  isPreProduction?: boolean,
  machineCategory?: MachineCategory
}

export default function useFGInpsectionLog(
  { productionOrder, workCenterId, department, isRefresh, isPreProduction, machineCategory }: UseFGInspectionLogParams
) : [ 
  OrderInspectionLog[],
  (updatedLog: OrderInspectionLog) => void,
  (updatedLogs: OrderInspectionLog[]) => void
] {
  const [ fgInspectionLogs, setFGInspectionLogs ] = useState<OrderInspectionLog[]>([]);

  const mutate = (updatedLog: OrderInspectionLog) => {
    setFGInspectionLogs(fgInspectionLogs.map(log => 
      log.id === updatedLog.id || log.inspectionType === updatedLog.inspectionType ? updatedLog : log));
  };

  const mutates = (updatedLogs: OrderInspectionLog[]) => {
    setFGInspectionLogs(updatedLogs);
  }

  useEffect(() => {
    if (isPreProduction) return;

    if (productionOrder === undefined || workCenterId === undefined) return;
    // logic
    // 1. if orderType is BULK or FG, show all Forms (PD_FILLING, PD_PACKING, QC_FILLING, QC_PACKING)
    // 2. if orderType is REPACK, show only PD_PACKING and QC_PACKING
    // 3. if orderType is CLAIM, show depending on Json
    const canEditLogic = (inspectionType: FGInspectionTypes) => 
      (department === Department.QC && inspectionType.startsWith('QC')) || 
      (department === Department.PRODUCTION && inspectionType.startsWith('PD'))

    getFGInspectionLogs(productionOrder.id, workCenterId).then(results => {
      let formTypes: FGInspectionTypes[] = [
        FGInspectionTypes.PD_FILLING,
        FGInspectionTypes.PD_PACKING,
        FGInspectionTypes.QC_FILLING,
        FGInspectionTypes.QC_PACKING
      ];

      if (productionOrder.orderType === OrderType.CLAIM) {
        if (!productionOrder.fgInspectionTypes) throw new Error("ไม่พบ FORM ของ CLAIM Order กรุณาแจ้ง QC Admin");

        formTypes = convertJson(productionOrder.fgInspectionTypes) as [FGInspectionTypes];
      } else if (productionOrder.orderType === OrderType.REPACK || machineCategory === MachineCategory.WITHPACK) {
        formTypes = [FGInspectionTypes.PD_PACKING, FGInspectionTypes.QC_PACKING];
      }

      setFGInspectionLogs(formTypes.map(formType => {
        const foundLog = results.find(log => log.inspectionType === formType);
        if (foundLog) return {
          ...foundLog,
          canEdit: canEditLogic(formType)
        };
        return {
          id: '',
          inspectionType: formType,
          inspectionStatus: null,
          canEdit: canEditLogic(formType),
          productionOrderId: productionOrder.id,
          workCenterId,
          formName: "",
          formUrl: "",
          createdAt: ""
        }
      }))
    }).catch(err => {
      console.error(err)
      alert(err.message)
    })
  }, [ productionOrder, department, workCenterId, isRefresh, isPreProduction, machineCategory ]);

  return [ fgInspectionLogs, mutate, mutates ]
}